import { IconComponent } from "./IconComponent";
import { iconMapping } from "@foodpilot/foods";
import ColorPickerField, { ColorPickerFieldProps } from "../../fields/ColorPickerField";
import { ComponentConfig } from "@measured/puck";

export type IconProps = {
    icon: keyof typeof iconMapping;
    size?: number;
    textSize?: number;
    color?: string;
    url?: string;
    target?: "_blank" | "_self";
    hoverEffect?: boolean;
    alignment?: "left" | "center" | "right";
    text?: string;
    textPosition?: "left" | "right" | "top" | "bottom";
    textColor?: string;
};

export const Icon: ComponentConfig<IconProps> = {
    label: "Icon",
    fields: {
        icon: {
            type: "select",
            label: "Icon",
            options: Object.keys(iconMapping).map((key) => ({ label: key, value: key })),
        },
        text: {
            type: "text",
            label: "Text (optional)",
            placeholder: "Enter text to display with icon",
        },
        size: {
            type: "number",
            label: "Icon Size",
        },
        textSize: {
            type: "number",
            label: "Text Size",
        },
        alignment: {
            type: "radio",
            label: "Alignment",
            options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
            ],
        },
        textPosition: {
            type: "radio",
            label: "Text Position",
            options: [
                { label: "Left", value: "left" },
                { label: "Right", value: "right" },
                { label: "Top", value: "top" },
                { label: "Bottom", value: "bottom" },
            ],
        },
        color: {
            type: "custom",
            label: "Icon Color",
            render: (props: ColorPickerFieldProps) => <ColorPickerField {...props} label="Icon Color" />,
        },
        textColor: {
            type: "custom",
            label: "Text Color",
            render: (props: ColorPickerFieldProps) => <ColorPickerField {...props} label="Text Color" />,
        },
        url: {
            type: "text",
            label: "Link URL (optional)",
            placeholder: "Enter URL to make icon clickable",
        },
        target: {
            type: "radio",
            label: "Link Target",
            options: [
                { label: "Same Tab", value: "_self" },
                { label: "New Tab", value: "_blank" },
            ],
        },
        hoverEffect: {
            type: "radio",
            label: "Hover Effect",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
    },
    defaultProps: {
        icon: "default",
        size: 16,
        textSize: 16,
        color: "#000000",
        url: "",
        target: "_blank",
        hoverEffect: true,
        alignment: "center",
        text: "",
        textPosition: "right",
        textColor: "#000000",
    },
    render: (props: IconProps) => <IconComponent {...props} />,
};

export default Icon;
